import servicesimg1 from '../assets/images/services/services-img1.webp';
import servicesimg2 from '../assets/images/services/services-img2.webp';
import servicesimg3 from '../assets/images/services/services-img3.webp';
import servicesimg4 from '../assets/images/services/services-img4.webp';
import servicesimg5 from '../assets/images/services/services-img5.webp';
import servicesimg6 from '../assets/images/services/services-img6.webp';

const ServicesList = [
  {
    id: 1,
    imgsrc: servicesimg1,
    icon: 'flaticon-data',
    title: 'Information Security',
    description:
      'Do it today. Remind yourself of someone you know who died suddenly and the fact that there is no guarantee that tomorrow will come.',
  },
  {
    id: 2,
    imgsrc: servicesimg2,
    icon: 'flaticon-author',
    title: 'Data Synchronization',
    description:
      'Positive pleasure-oriented goals are much more powerful motivators than negative fear-based ones. Although each is successful separately.',
  },
  {
    id: 3,
    imgsrc: servicesimg3,
    icon: 'flaticon-icon-149196',
    title: 'Mobile Platforms',
    description:
      'We know this in our gut, but what can we do about it? How can we motivate ourselves? One of the most difficult aspects of achieving success.',
  },
  {
    id: 4,
    imgsrc: servicesimg4,
    icon: 'flaticon-chart',
    title: 'Process Automation',
    description:
      'It must come from within as the natural product of your desire to achieve something and your belief that you are capable to succeed at your goal.',
  },
  {
    id: 5,
    imgsrc: servicesimg5,
    icon: 'flaticon-design',
    title: 'Event Processing',
    description:
      'There is really no magic to it and it’s not reserved only for a select few people. As such, success really has nothing to do with luck.',
  },
  {
    id: 6,
    imgsrc: servicesimg6,
    icon: 'flaticon-group',
    title: 'Content Management',
    description:
      'There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.',
  },
];

export default ServicesList;
